import { Button, Input, InputNumber, Modal, Radio } from "antd";
import { useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";

export default function ({ deviceId, orgId }) {
  const [ip, setIp] = useState("");
  const [port, setPort] = useState(80);
  const [type, setType] = useState("nvr");
  const [modalShow, setModalShow] = useState(false);
  const { sendWsRequest } = useWsSender();
  const deviceForward = async () => {
    try {
      const res: any = await sendWsRequest(
        "device.remote_service.open",
        {
          deviceOpenRemoteService: {
            deviceId: deviceId.toString(),
            deviceType: type,
            network:
              type === "type_unknown"
                ? {
                    ip,
                    port,
                  }
                : undefined,
          },
        },
        { orgId },
      );
      const query =
        "?expiredAt=" +
        res.deviceOpenRemoteServiceReply.cookie.expiredAt +
        "&name=" +
        res.deviceOpenRemoteServiceReply.cookie.name +
        "&value=" +
        res.deviceOpenRemoteServiceReply.cookie.value;
      window.open(
        "https://" + res.deviceOpenRemoteServiceReply.domain + query,
        "_blank",
      );
      setModalShow(false);
    } catch (e) {
      console.error(e);
      showToast(1, "Forward failed");
    }

    return;
  };
  return (
    <>
      <Button onClick={() => setModalShow(true)} type="link">
        Foward
      </Button>
      <Modal
        title={"Forward to device"}
        open={modalShow}
        okButtonProps={{ className: "primaryButton" }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
        onOk={deviceForward}
      >
        <Radio.Group
          value={type}
          onChange={(e) => setType(e.target.value)}
          options={[
            { label: "NVR", value: "nvr" },
            { label: "CUSTOM", value: "type_unknown" },
          ]}
        />
        <div style={{ marginTop: "12px" }}>
          <span>IP:</span>
          <Input
            disabled={type !== "type_unknown"}
            value={ip}
            onChange={(e) => setIp(e.target.value)}
            style={{ width: "200px" }}
          />
        </div>
        <div style={{ marginTop: "12px" }}>
          <span>Port:</span>
          <InputNumber
            value={port}
            onChange={(e) => setPort(e)}
            disabled={type !== "type_unknown"}
          />
        </div>
      </Modal>
    </>
  );
}
